var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ResourceLabel"},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"has-text-grey"},[_vm._v(_vm._s(_vm.missing || 'Missing label'))])])}
var staticRenderFns = []

export { render, staticRenderFns }